import angular from 'angular';
import calendarRangePicker from './calendarRangePicker';

export default angular
  .module('calendarRangePicker', [])
  .component('calendarRangePicker', calendarRangePicker).name;
